var _g, _g2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatRoomPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 60,
    viewBox: "0 0 83 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3048_141075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.15227 22.8648C0.846671 21.7243 1.00666 20.5091 1.59703 19.4865C2.18741 18.4639 3.15982 17.7178 4.30034 17.4122L32.3959 9.884C33.5364 9.5784 34.7516 9.73838 35.7742 10.3288C36.7967 10.9191 37.5429 11.8915 37.8485 13.0321L45.3767 41.1276C45.6823 42.2681 45.5223 43.4833 44.9319 44.5059C44.3415 45.5285 43.3691 46.2746 42.2286 46.5802L14.1331 54.1084C12.9925 54.414 11.7773 54.254 10.7548 53.6637C9.73221 53.0733 8.98605 52.1009 8.68045 50.9603L1.15227 22.8648Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.6601,
    cy: 31.6603,
    r: 10,
    transform: "rotate(60 24.6601 31.6603)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3203 26.6603C30.5603 21.8798 24.4405 20.24 19.6601 23C14.8796 25.76 13.2398 31.8798 15.9998 36.6603C18.7598 41.4407 24.8796 43.0805 29.6601 40.3205C34.4405 37.5605 36.0803 31.4407 33.3203 26.6603ZM17.2925 34.7592C15.7418 31.0934 17.1267 26.7721 20.6601 24.7321C21.197 24.4221 21.7479 24.1963 22.3152 24.0189L20.562 30.5622L19.696 31.0622C18.7433 31.6122 18.4139 32.8416 18.9639 33.7942L17.2925 34.7592ZM22.9416 39.4643C23.513 38.8342 23.6453 37.9033 23.1953 37.1239L22.6953 36.2579L25.2934 34.7579C25.7697 34.4829 25.9344 33.8682 25.6594 33.3918L22.6594 28.1957L24.3915 27.1957L25.3915 28.9277C25.6665 29.4041 26.2812 29.5688 26.7575 29.2938L28.4896 28.2938L29.4896 30.0258C30.0396 30.9785 31.269 31.3079 32.2216 30.7579L32.5767 30.5529C33.0111 33.6853 31.5606 36.913 28.6594 38.588C26.8581 39.628 24.8213 39.8802 22.9416 39.4643Z",
    fill: "#222222"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_3048_141075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0396 6.85558C44.63 5.83302 45.6024 5.08686 46.7429 4.78126C47.8834 4.47566 49.0986 4.63564 50.1212 5.22602L75.311 19.7693C76.3335 20.3597 77.0797 21.3321 77.3853 22.4727C77.6909 23.6132 77.5309 24.8284 76.9405 25.8509L62.3972 51.0407C61.8068 52.0633 60.8344 52.8094 59.6939 53.1151C58.5534 53.4207 57.3382 53.2607 56.3156 52.6703L31.1258 38.127C30.1033 37.5366 29.3571 36.5642 29.0515 35.4237C28.7459 34.2831 28.9059 33.0679 29.4963 32.0454L44.0396 6.85558Z",
    fill: "#F3F3F5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0247 29.8154L48.298 30.5334L48.298 30.5334L48.2902 30.5367C47.3466 30.9367 46.8495 31.9706 47.112 32.9504L47.1127 32.953L48.0604 36.4596C48.0606 36.4601 48.0607 36.4606 48.0609 36.4611L48.0612 36.4622L49.2679 36.136L50.0247 29.8154ZM50.0247 29.8154L48.1756 30.055M50.0247 29.8154L48.1756 30.055M48.1756 30.055L48.1692 30.0558L48.0086 28.8162L48.1859 30.0535C48.1825 30.054 48.1791 30.0545 48.1756 30.055ZM51.2889 37.525L63.0497 28.2693L63.0525 28.267C64.4569 27.1552 63.8552 24.9096 62.083 24.6488L62.0794 24.6483L47.2664 22.5131C45.8006 22.293 44.6304 23.6542 45.0028 25.0484L45.0026 25.0473L46.2107 24.7264L45.0032 25.0499L51.2889 37.525Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 2.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_3048_141075",
    x: 23.8994,
    y: 0.628906,
    width: 58.6377,
    height: 58.6387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0068 0 0 0 0 0.0102133 0 0 0 0 0.0132 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3048_141075"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0068 0 0 0 0 0.0102133 0 0 0 0 0.0132 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3048_141075",
    result: "effect2_dropShadow_3048_141075"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0068 0 0 0 0 0.0102133 0 0 0 0 0.0132 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_3048_141075",
    result: "effect3_dropShadow_3048_141075"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_3048_141075",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3048_141075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.9907,
    height: 37.9907,
    fill: "white",
    transform: "translate(0 18.5645) rotate(-15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatRoomPlaceholder);
export default __webpack_public_path__ + "static/media/chat-room-placeholder.49f1563cc12fc2838eefae09865d373c.svg";
export { ForwardRef as ReactComponent };